import ProfessionalIcon from "../component/ProfessionalIcon"
import PatientIcon from "../component/PatientIcon"
import { useNavigate } from "react-router-dom"
import { NAVIGATION_VIEW, NavigationPaths } from "../navigation/NavigationController"
import { useAppSelector } from "../redux/store/hooks"
import { selectProfessionalAuthenticationState } from "../redux/ProfessionalAuthentication"

function HelpView() {

    const navigate = useNavigate()

    const authenticated = useAppSelector(selectProfessionalAuthenticationState)

    return (
        <div className={"w-full flex mt-20 flex-col sm:flex-row space-y-10 sm:space-y-0"}>
            <div className={"flex-1 flex items-center justify-center"}>
                <div
                    onClick={() => navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_HELP_VIEW].path)}
                    className={"flex items-center justify-center w-[300px] h-[100px] rounded-xl space-x-4 bg-white bg-opacity-30 hover:bg-opacity-60 cursor-pointer shadow"}>
                    <PatientIcon />
                    <div>Hilfe für Patient:innen</div>
                </div>
            </div>
            <div className={"flex-1 flex items-center justify-center"}>
                <div
                    onClick={() => {
                        if(authenticated) {
                            navigate(NavigationPaths[NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW].path)
                        } else {
                            navigate(NavigationPaths[NAVIGATION_VIEW.PROFESSIONAL_HELP_VIEW_TUTORIAL].path)
                        }
                    }}
                    className={"flex items-center justify-center w-[300px] h-[100px] rounded-xl space-x-4 bg-white bg-opacity-30 hover:bg-opacity-60 cursor-pointer shadow"}>
                    <ProfessionalIcon />
                    <div>Hilfe für Ärzt:innen</div>
                </div>
            </div>
        </div>
    )
}

export default HelpView
